import React, { useState, useEffect } from 'react';
import api from '@api';
import './UserSettingsPage.css';
import { useAuth } from '../../../context/AuthContext';

function UserSettingsPage() {
  const { user } = useAuth();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isEditMode, setIsEditMode] = useState(true);
  const [theme, setTheme] = useState('');

  useEffect(() => {
    if (user?.id) {
      const fetchUserDetails = async () => {
        try {
          const res = await api.get(`/api/usersv2/${user.id}`, { withCredentials: true });
          setUsername(res.data.user.username);
          setEmail(res.data.user.email);
          setTheme(res.data.user.theme);
        } catch (err) {
          setError('Failed to fetch user details');
        }
      };
      fetchUserDetails();
    }
  }, [user?.id]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    const updatedUserData = {
      username: username || user.username,
      email: email || null,
      oldPassword: oldPassword || null,
      password: password || null,
      theme: theme ?? 'light',
    };

    try {
      const res = await api.put(`/api/usersv2/${user.id}`, updatedUserData, {
        withCredentials: true,
      });

      setMessage('User updated successfully');
      setUsername(res.data.user.username);
      setEmail(res.data.user.email);
      setTheme(res.data.user.theme)
      setIsEditMode(false);
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || 'Failed to update user');

      // Clear the error after 3 seconds
      setTimeout(() => {
        setError('');
      }, 3000); // 3000 milliseconds = 3 seconds
    }
  };

  const handleEditClick = () => {
    setIsEditMode(!isEditMode);
    if (!isEditMode) {
      setOldPassword('');
      setPassword('');
    }
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div className="user-settings-page">
      <div className="user-settings-card">
        <div className="user-settings-header">
          <div className="user-settings-avatar">
            {user.username?.slice(0, 2)}
          </div>

          <div>
            <p className="user-settings-eyebrow">Account Settings</p>
            <h2>User Settings</h2>
            <p className="user-settings-subtitle">
              Manage your login details and account information.
            </p>
          </div>
        </div>

        {error && <div className="user-settings-alert error">{error}</div>}
        {message && <div className="user-settings-alert success">{message}</div>}

        {!isEditMode && (
          <div className="user-settings-view">
            <div className="user-settings-row">
              <span>Username</span>
              <strong>{username}</strong>
            </div>

            <div className="user-settings-row">
              <span>Email</span>
              <strong>{email || 'No email added'}</strong>
            </div>

            <button className="user-settings-button primary" onClick={handleEditClick}>
              Edit Settings
            </button>
          </div>
        )}

        {isEditMode && (
          <form className="user-settings-form" onSubmit={handleSubmit}>
            <div className="user-settings-grid">
              <div className="user-settings-field">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              <div className="user-settings-field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="user-settings-divider">
              <span>Password</span>
            </div>

            <div className="user-settings-grid">
              <div className="user-settings-field">
                <label htmlFor="oldPassword">Old Password</label>
                <input
                  type="password"
                  id="oldPassword"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  placeholder="Enter old password"
                />
              </div>

              <div className="user-settings-field">
                <label htmlFor="password">New Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter new password"
                />
              </div>
            </div>

            <div className="user-settings-actions">
              <button className="user-settings-button primary" type="submit">
                Save Changes
              </button>

              <button
                className="user-settings-button secondary"
                type="button"
                onClick={() => setIsEditMode(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default UserSettingsPage;
